import { render } from "./ContactInformation.vue?vue&type=template&id=0a081811&ts=true"
import script from "./ContactInformation.vue?vue&type=script&lang=ts"
export * from "./ContactInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__